<app-dashboard-card title="Atención en el hogar" icon="monitor_heart" accentColor="#607d8b">
  <div card-content class="home-attendance-actions">
    <a mat-stroked-button [routerLink]="['/units', unitId, 'member-follow-up']" [queryParams]="{ focus: 'visits' }">
      <mat-icon>recent_actors</mat-icon>
      <span>Seguimiento de VAE</span>
    </a>
    <a mat-stroked-button [routerLink]="['/units', unitId, 'member-follow-up']" [queryParams]="{ focus: 'attendance' }">
      <mat-icon>event_busy</mat-icon>
      <span>Seguimiento de concurrencia</span>
    </a>
    <a mat-stroked-button [routerLink]="['/units', unitId, 'member-follow-up']" [queryParams]="{ focus: 'communion' }">
      <mat-icon svgIcon="chalice"></mat-icon>
      <span>Seguimiento de Santa Cena</span>
    </a>
  </div>
</app-dashboard-card>
